import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Query } from '../reactApolloCompat';
import { getAuthClient, resetClient } from '../utils/apollo';
import { indexOf } from '../utils/arrays';
import Spinner from './loading/Spinner';
import { clearToken } from '../utils/sessions';
import { setSnackbarMessage } from '../context/SnackbarMessage';

class GatedComponent extends React.Component {
    render() {
        const { showLoading, canViewCode, canEditCode, children } = this.props;

        if (!canViewCode && !canEditCode) {
            return children();
        }

        return (
            <Fragment>
                <Query query={permissionsQuery} client={getAuthClient()}>
                    {({ data, loading }) => {
                        if (loading) return showLoading ? <Spinner /> : null;
                        const user = data && data.readCurrentUser;
                        if (!user) {
                            clearToken();
                            resetClient();
                            setSnackbarMessage('Unrecognised user was logged out.');
                            return null;
                        }
                        const userCodes = (user && JSON.parse(user.AllPermissions)) || [];

                        if (canViewCode && indexOf(userCodes, x => x === canViewCode || x === 'ADMIN') < 0) {
                            return null;
                        }

                        const canEdit = canEditCode && indexOf(userCodes, x => x === canEditCode || x === 'ADMIN') >= 0;

                        return children(canEdit, data);
                    }}
                </Query>
            </Fragment>
        );
    }
}

GatedComponent.propTypes = {
    children: PropTypes.func.isRequired
};

export const CurrentUserFragment = gql`
    fragment CurrentUserFragment on Member {
        ID
        FirstName
        Surname
        Email
        Phone
        AllPermissions
        Groups {
            ID
            Code
            Title
        }
    }
`;

export const permissionsQuery = gql`
    ${CurrentUserFragment}
    query {
        readCurrentUser {
            ...CurrentUserFragment
        }
    }
`;

export default GatedComponent;
